import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';
import MiTooltipPersonalizado from './MiTooltipPersonalizado';

import Banner from './Banner';
import ChatBot from './Chatbot';
import SoportePsicologico from './SoportePsicologico';
import Cursos from './Cursos';
import Footer from './Footer';
import EstamosContigo from './EstamosContigo';
import AccesosDirectos from './AccesosDirectos';
import EncuentraAyuda from './EncuentraAyuda';
import TiposViolencia from './TiposViolencia';
import ApoyoPsicologico from './ApoyoPsicologico';
import Carrusel from './Carrusel';
import VideoSection from './Videos';

import '../index.css';
import '../index.postcss.css';

const Index = () => {

  const [run, setRun] = useState(false);

  // Mostrar tour solo la primera vez
  useEffect(() => {
    const yaVioTour = localStorage.getItem("tourCamiVisto");

    if (!yaVioTour) {
      setRun(true);
    }
  }, []);

  // Guardar cuando termine el tour
  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if (status === "finished" || status === "skipped") {
      localStorage.setItem("tourCamiVisto", "true");
      setRun(false);
    }
  };

  const misPasos = [
    {
      target: '#Banner',
      content: '¡Te damos la bienvenida! A Caminemos Juntas.',
      disableBeacon: true,
    },
    {
      target: '#EncuentraAyuda',
      content: 'En esta sección puedes encontrar ayuda inmediata, acceder a contactos de emergencia y ver servicios con los que contamos.',
    },
    {
      target: '#chatbot',
      content: 'Si necesitas ayuda inmediata, ¡habla con nuestro asistente virtual, disponible 24/7!',
    },
    {
      target: '#estamoscontigo',
      content: 'Accede al Mapa de Centros de Atención y refugio para encontrar el más cercano a ti.',
    },
    {
      target: '#psicologico',
      content: '¿Necesitas apoyo psicológico? Aquí puedes agendar una cita con nuestra Psicóloga para una asesoría totalmente gratis y anónima.',
    },
    {
      target: '#test',
      content: 'Identifica y previene situaciones de riesgo. ¡Haz el test!',
    },
    {
      target: '#Tiposviolencia',
      content: 'Identifica y conoce los tipos de violencia.',
    },
    {
      target: '#Videos',
      content: 'En este apartado puedes encontrar videos educativos, de prevención y relacionados a la violencia de género.',
    },
    {
      target: '#cursos',
      content: '¿Te gustaría tomar un curso gratuito? Aquí encontrarás cursos y talleres para empoderarte.',
    },
    {
      target: '#apoyopsicologico',
      content: '¿Quiénes somos? Conócenos, Cami es un desarrollo hecho por y para mujeres.',
    },
    {
      target: '#contacto',
      content: '¿Quieres contactarnos? Aquí está nuestra información de contacto. Síguenos en redes sociales y no te pierdas lo nuevo de CAMI. ¡Tu apoyo puede salvar vidas!',
    },
  ];

  return (
    <main className='font-sans text-[#24363a]'>

      <Banner id="Banner" />

      <EncuentraAyuda id="EncuentraAyuda" />
      <AccesosDirectos id="psicologico" />

      {/*<SoportePsicologico title="Algunas cosas que puedes hacer para" content="Frenar la violencia de género" />*/}

      <EstamosContigo
        id="estamoscontigo"
        title="Apoyo Legal"
        content="Información sobre apoyo psicológico."
      />

      <TiposViolencia id="Tiposviolencia" />
      <VideoSection id="Videos" />

      <Cursos
        id="cursos"
        title="Cursos para Mujeres"
        content="Lista de cursos disponibles."
      />

      <ApoyoPsicologico
        id="apoyopsicologico"
        title="Apoyo Psicologico"
        content="Información sobre apoyo psicológico."
      />

      <ChatBot id="chatbot" />
      <Footer id="contacto" />

      <Joyride
        steps={misPasos}
        run={run}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        tooltipComponent={MiTooltipPersonalizado}
        callback={handleJoyrideCallback}
        styles={{
          options: {
            overlayColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 1000,
          }
        }}
      />

    </main>
  );
};

export default Index;